app.service("MatrixProductService", ['$rootScope', function ($rootScope) {

    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    const MatrixProductModel = modelConstructor.extend(modelConstructor.BasicModel, {
        name: "Matrix Product",
        id: "matrix_product",
        product_models: {},
        is_prepared: false,
        onPreparedCallbacks: [],
        categories: {
            parent: [],
            alpha: [],
            beta: [],
            unit: [],
            width: [],
            internal: [],
            hinge_hole: []
        },
        requirePrepared: function (callback) {
            const model = this.root;
            if (model.is_prepared) {
                callback();
            } else {
                model.onPreparedCallbacks.push(callback);
            }
        }
    });

    this.factory = new modelConstructor.ModelFactory({
        birth: function (values) {
            return new MatrixProductModel(values);
        },
        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const requestRangeID = variationIDs.request_range_id;

        const requestRangeIDs = requestRangeID ? [requestRangeID] : ["pronto", "valore", "bella", "zurfiz"];
        const requestRangeVariationIDs = siteHelper.simpleCloneObject(variationIDs);
        model.parent_category_id = requestRangeVariationIDs.parent_category_id;
        let includeParentCategoryIDs = null;
        if (model.parent_category_id) {
            if (model.parent_category_id !== "non_component") {
                includeParentCategoryIDs = [model.parent_category_id];
            } else {
                includeParentCategoryIDs = [];

                const baseComponentCache = $rootScope.service.cache_local_server.getComponentObject("solution");
                if (baseComponentCache) {
                    for (let parentCategoryID in baseComponentCache.parent_category) {
                        if (parentCategoryID !== "component" && parentCategoryID !== "non_component") {
                            includeParentCategoryIDs.push(parentCategoryID)
                        }
                    }
                }
            }
        }
        model.include_parent_category_ids = includeParentCategoryIDs;
        model.alpha_category_id = requestRangeVariationIDs.alpha_category_id;
        model.include_alpha_category_ids = model.alpha_category_id ? [model.alpha_category_id] : null;
        delete requestRangeVariationIDs.parent_category_id;
        const productModels = {};
        for (let i = 0; i < requestRangeIDs.length; i++) {
            const rangeID = requestRangeIDs[i];
            requestRangeVariationIDs.request_range_id = rangeID;
            productModels[rangeID] = $rootScope.factory.product_solution.getModel(requestRangeVariationIDs)
        }

        model.product_models = productModels;

        function haveRequiredData() {
            for (let key in productModels) {
                if (!productModels[key].has_a_completed_request) {
                    return false;
                }
            }
            return true;
        }

        function onChoicesReady() {
            parseData(model);
            model.is_prepared = true;
            for (let i = 0; i < model.onPreparedCallbacks.length; i++) {
                model.onPreparedCallbacks[i]();
            }
            model.onPreparedCallbacks.length = 0;
        }

        function requireModelData(productModel) {
            function onHaveData() {
                if (!haveRequiredData()) {
                    return
                }
                onChoicesReady()
            }

            if (productModel.has_a_completed_request) {
                onHaveData();
            } else {
                productModel.apiRequire(onHaveData)
            }
        }

        if (haveRequiredData()) {
            onChoicesReady()
        } else {
            parseData(model)
            for (let key in productModels) {
                requireModelData(productModels[key])
            }
        }
    }


    function parseData(model) {
        collectProducts(model);
        const choiceList = model.choiceList();
        addProductCategories(model, choiceList);
        addMatrixCategories(model, choiceList);
    }

    function collectProducts(model) {
        const choiceOrder = [];
        const choices = {};

        for (let key in model.product_models) {
            const productModel = model.product_models[key];
            const fromChoiceList = productModel.choiceList();
            for (let i = 0; i < fromChoiceList.length; i++) {
                let choice = fromChoiceList[i]
                if (choices[choice.id]) {
                    continue;
                }
                choice = choice.clone();
                choices[choice.id] = choice;
                choiceOrder.push(choice.id)
            }
        }

        model.choice_order = choiceOrder;
        model.choices = choices;
    }

    function addProductCategories(model, choiceList) {

        model.categories = $rootScope.service.product_solution.createCategories(choiceList, model.include_parent_category_ids);
    }

    function addMatrixCategories(model, choiceList) {

        const internalTypeIDs = ["internal", "wingline_internal_left", "wingline_internal_right", "internal_left", "internal_right", "drip_tray", "door"];
        const knownHingeHoleOptionIDs = ["left", "right"];
        const internalCategories = {};
        const hingeHoleCategories = {};

        for (let i = 0; i < choiceList.length; i++) {
            const product = choiceList[i];

            const internalIDs = [];
            if (product.options) {
                for (let key in product.options) {
                    if (internalTypeIDs.includes(key)) {
                        const items = product.options[key].items;
                        if (items) {
                            for (let internalID in items) {
                                const item = items[internalID];
                                const itemName = item.name ? item.name : "Unnamed";
                                const parts = internalID.split("_");
                                if (parts.length > 1) {
                                    const suffix = parts[parts.length - 1];
                                    if (!isNaN(suffix) && !itemName.includes(suffix)) {
                                        internalID = internalID.slice(0, -(suffix.length + 1));
                                    }
                                }

                                if (internalIDs.indexOf(internalID) !== -1) {
                                    continue;
                                }
                                let internal = internalCategories[internalID];
                                if (!internal) {
                                    internal = {
                                        id: internalID,
                                        name: itemName,
                                        product_ids: []
                                    }
                                    internalCategories[internalID] = internal;
                                }
                                internal.product_ids.push(product.id);
                                internalIDs.push(internalID);
                            }
                        }
                    }
                }
            }
            product.internalIDs = internalIDs;

            const hingeHoleIDs = [];
            if (product.hinge_hole_options) {
                for (let k = 0; k < product.hinge_hole_options.length; k++) {
                    const hingeHoleOption = product.hinge_hole_options[k];
                    if (hingeHoleOption.value === "none") {
                        continue;
                    }
                    let hingeHoleChoice = hingeHoleCategories[hingeHoleOption.value];
                    if (!hingeHoleChoice) {
                        hingeHoleChoice = {
                            id: hingeHoleOption.value,
                            name: hingeHoleOption.name,
                            product_ids: []
                        }
                        hingeHoleCategories[hingeHoleChoice.id] = hingeHoleChoice;
                    }
                    hingeHoleChoice.product_ids.push(product.id);
                    hingeHoleIDs.push(hingeHoleChoice.id);
                }
            }
            product.hingeHoleIDs = hingeHoleIDs;
        }

        const internalCategoryArray = [];
        const hingeHoleCategoryArray = [];

        for (let key in internalCategories) {
            internalCategoryArray.push(internalCategories[key]);
        }
        internalCategoryArray.sort(function (a, b) {
            if (a.id === 'none') {
                return -1;
            }
            if (b.id === 'none') {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;
        })
        for (let hingeHoleID in hingeHoleCategories) {
            hingeHoleCategoryArray.push(hingeHoleCategories[hingeHoleID]);
        }
        hingeHoleCategoryArray.sort(function (a, b) {
            let aIndex = knownHingeHoleOptionIDs.indexOf(a.id);
            let bIndex = knownHingeHoleOptionIDs.indexOf(b.id);
            aIndex = aIndex >= 0 ? aIndex : Number.MAX_SAFE_INTEGER;
            bIndex = bIndex >= 0 ? bIndex : Number.MAX_SAFE_INTEGER;
            return aIndex < bIndex ? -1 : 1;
        })

        model.categories.internal = internalCategoryArray;
        model.categories.hinge_hole = hingeHoleCategoryArray;
    }

}]);